import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Resetpassword from "./pages/Resetpassword";
import Forgotpassword from "./pages/Forgotpassword";
import MainLayout from "./components/MainLayout";
import Setting from "./pages/Setting";
import Customers from "./pages/Customers"
import Profile from "./pages/Profile";
import { ConfigProvider } from 'antd';
import ReportUser from "./pages/ReportUser";
import DiamondUser from "./pages/DiamondUser";
import Notification from './pages/Notification';
import NotificationLog from './pages/NotificationLog';
import Page from "./pages/Page";
import PaymentLog from "./pages/PaymentLog";
import UserSubscription from "./pages/UserSubscription";
import UserPayment from "./pages/UserPayment";
import Chat from "./pages/chat/Chat";
import Jackpot from "./pages/jackpot";
import CreateJackpot from "./pages/jackpot/create";
import EditJackpot from "./pages/jackpot/edit";
import JackpotEntries from "./pages/jackpot-entries";
import Price from "./pages/price";
import CreatePrice from "./pages/price/create";
import EditPrice from "./pages/price/edit";
import RedemCode from "./pages/redem-code";
import CreateRedemCode from "./pages/redem-code/create";
import EditRedemCode from "./pages/redem-code/edit";
import HoleOutPrize from "./pages/hole-out-prize";
import CreateHoleOutPrize from "./pages/hole-out-prize/create";
import EditHoleOutPrize from "./pages/hole-out-prize/edit";
import HoleOutPrice from "./pages/hole-out-price";
import CreateHoleOutPrice from "./pages/hole-out-price/create";
import EditHoleOutPrice from "./pages/hole-out-price/edit";
import UserSubscriptionPayment from "./pages/UserSubscriptionPayment";
import UserRedeemCode from "./pages/UserRedeemCode";
import UserCreditUsed from "./pages/CreditUsed";
import LogsUserShot from "./pages/LogsUserShot";
import ChallengeEntries from "./pages/hole-out-prize-entries";
import ViewJackpotExtries from "./pages/jackpot-entries/view";
import ViewChallengeEntries from "./pages/hole-out-prize-entries/view";
import Subscription from "./pages/subscription";
import CreateSubscription from "./pages/subscription/create";
import EditSubscription from "./pages/subscription/edit";
import HoleOutRule from "./pages/hole-out-rule";
import HoleInOneRule from "./pages/hole-in-one-rule";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#12361D',
          borderRadius: 2,
        },
        components: {
          Menu: {
            itemColor: 'white',
            itemSelectedBg: 'white',
            itemSelectedColor: 'white',
            BgColor: 'white',
          },
        }
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<Resetpassword />} />
          <Route path="/forgot-password" element={<Forgotpassword />} />
          <Route path="/page/:type" element={<Page />} />
          <Route path="/admin" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="setting" element={<Setting />} />
            <Route path="hole-in-one-price" element={<Price />} />
            <Route path="hole-in-one-price/create" element={<CreatePrice />} />
            <Route path="hole-in-one-price/:id" element={<EditPrice />} />
            <Route path="hole-in-one-prize" element={<Jackpot />} />
            <Route path="hole-in-one-prize/create" element={<CreateJackpot />} />
            <Route path="hole-in-one-prize/:id" element={<EditJackpot />} />
            <Route path="hole-out-price" element={<HoleOutPrice />} />
            <Route path="hole-out-price/create" element={<CreateHoleOutPrice />} />
            <Route path="hole-out-price/:id" element={<EditHoleOutPrice />} />
            <Route path="hole-out-prize" element={<HoleOutPrize />} />
            <Route path="hole-out-prize/create" element={<CreateHoleOutPrize />} />
            <Route path="hole-out-prize/:id" element={<EditHoleOutPrize />} />
            <Route path="hole-out-rule" element={<HoleOutRule />} />
            <Route path="hole-in-one-rule" element={<HoleInOneRule />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="subscription/create" element={<CreateSubscription />} />
            <Route path="subscription/:id" element={<EditSubscription />} />
            <Route path="redem-code" element={<RedemCode />} />
            <Route path="redem-code/create" element={<CreateRedemCode />} />
            <Route path="redem-code/:id" element={<EditRedemCode />} />
            <Route path="hole-in-one-video-submissions" element={<JackpotEntries />} />
            <Route path="hole-in-one-video-submissions/:id" element={<ViewJackpotExtries />} />
            <Route path="hole-out-video-submissions" element={<ChallengeEntries />} />
            <Route path="hole-out-video-submissions/:id" element={<ViewChallengeEntries />} />
            <Route path="profile/:id" element={<Profile />} />
            <Route path="customers" element={<Customers />} />
            <Route path="report-user/" element={<ReportUser />} />
            <Route path="diamond-user" element={<DiamondUser />} />
            <Route path="send-notification" element={<Notification />} />
            <Route path="notification-log" element={<NotificationLog />} />
            <Route path="subscription-logs" element={<PaymentLog />} />
            <Route path="user-subscriptions" element={<UserSubscription />} />
            <Route path="user-payments" element={<UserPayment />} />
            <Route path="user-subscription-payments" element={<UserSubscriptionPayment />} />
            <Route path="user-redeem-code" element={<UserRedeemCode />} />
            <Route path="user-credit-usage" element={<UserCreditUsed />} />
            <Route path="logs-user-shot" element={<LogsUserShot />} />
            <Route path="chat" element={<Chat />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
}
export default App;